export const getEnvironmentName = () => {
  const hostname = window?.location?.hostname;

  if (hostname.startsWith("app.")) {
    return "production";
  }
  if (hostname.startsWith("staging.")) {
    return "staging";
  }
  if (hostname.startsWith("test.")) {
    return "test";
  }

  return import.meta.env;
};

export const isProduction = () => {
  return getEnvironmentName() === "production";
};
